export const loadGapiScript = ()=>{
    return new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = 'https://apis.google.com/js/api.js';
        document.body.append(script);
        script.onload = ()=>{
            resolve(script);
        };
        script.onerror = (e)=>{
            reject(e);
        }
    })     
}

export const initGapiClient = ()=>{
    return new Promise((resolve, reject)=>{
        gapi.load('client', (e)=>{ 
            gapi.client.init({}).then(()=>{
                gapi.client.setToken({access_token: localStorage.getItem('gtoken')});
                resolve(gapi);
            });
        });
    });
};

export const initGapi = async ()=>{
    try {
        const gapiElement = await loadGapiScript();
        await initGapiClient();
        return true;
    } catch(e){
        if (e?.status == 403){
            console.log('Drive config error')
        }
        if (e?.status == 401){
            console.log('Drive not authorized or expired')
        }
        console.error(e);
    }
    return false;
}